export const FETCH_NETWORK_REPORT_DATA =
  'ipfabric/DownloadReport/FETCH_NETWORK_REPORT_DATA';
